const name = 'circle-7';

const contents = '<path fill="#FFF" d="M30.876 55.086H25.49l7.706-18.643 3.397-5.137v-.497l-4.806.497H20.85v-4.392h20.3v3.48z"/>';

/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: '7',
};

export default icon;
